import { FC } from "react";
import { createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%"
      },
      body: {
        height: "100%",
        width: "100%",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        lineHeight: "1.0",
        letterSpacing: "0.00938em"
      },
      "#root": {
        height: "100%",
        width: "100%",
        minHeight: "100vh"
      }
    }
  })
);

const GlobalStyles: FC = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
